import React from 'react';
import { Select } from 'antd';
import analytics from '../../services/analytics';

const LanguageSelector = ({ selectedLanguage, languageList, switchLanguage, problemId }) => {
  const langDescMap = {
    python3: 'Python 3',
    ruby3: 'Ruby 3',
    javascript: 'Javascript',
    cpp: 'C++',
    java: 'Java',
    c: 'C',
  };

  const handleLanguageChange = newLanguage => {
    analytics.trackLanguageChanged(newLanguage, problemId);
    switchLanguage(newLanguage);
  };

  return (
    <Select
      value={selectedLanguage}
      id="menuList"
      style={{ fontSize: '16px', padding: '0px', textAlign: 'left' }}
      onChange={handleLanguageChange}
      options={languageList.map(l => ({
        value: l,
        label: langDescMap[l],
      }))}
    />
  );
};

export default LanguageSelector;
